module.exports = __webpack_public_path__ + "media/images/icons/globe-8dd9337abc629728edaf3b00fd4f11f1.svg";